import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { keyframes } from "@mui/system";

const spin = keyframes`
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
`;

const spinReverse = keyframes`
  from { transform: rotate(0deg); }
  to   { transform: rotate(-360deg); }
`;

const pulse = keyframes`
  0%, 100% { opacity: 0.4; }
  50%       { opacity: 1; }
`;

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export default function Loader() {
    const theme = useTheme();
    const primary = theme.palette.primary.main;
    const secondary = theme.palette.secondary.main;
    const bg = theme.palette.background.default;

    return (
        <Box
            sx={{
                position: "fixed",
                inset: 0,
                zIndex: 9999,
                backgroundColor: bg,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 3,
            }}
        >
            {/* Spinner */}
            <Box sx={{ position: "relative", width: 72, height: 72 }}>
                {/* Outer ring — gold */}
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        borderRadius: "50%",
                        border: "3px solid transparent",
                        borderTopColor: primary,
                        borderRightColor: primary,
                        animation: `${spin} 1s linear infinite`,
                        filter: `drop-shadow(0 0 6px ${primary}88)`,
                    }}
                />
                {/* Inner ring — cyan */}
                <Box
                    sx={{
                        position: "absolute",
                        inset: 12,
                        borderRadius: "50%",
                        border: "2px solid transparent",
                        borderTopColor: secondary,
                        borderLeftColor: secondary,
                        animation: `${spinReverse} 0.75s linear infinite`,
                        filter: `drop-shadow(0 0 4px ${secondary}88)`,
                    }}
                />
                {/* Center dot */}
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        backgroundColor: primary,
                        animation: `${pulse} 1.5s ease-in-out infinite`,
                        boxShadow: `0 0 8px ${primary}`,
                    }}
                />
            </Box>

            {/* Label */}
            <Typography
                variant="caption"
                sx={{
                    color: "text.secondary",
                    letterSpacing: "0.2em",
                    textTransform: "uppercase",
                    fontSize: "0.65rem",
                    animation: `${fadeUp} 0.4s ease-out forwards, ${pulse} 2s ease-in-out 0.4s infinite`,
                }}
            >
                A carregar...
            </Typography>
        </Box>
    );
}
